import { Box, useTheme } from "@mui/material";
import FactCheckIcon from "@mui/icons-material/FactCheck";
import SchoolIcon from "@mui/icons-material/School";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import EventIcon from "@mui/icons-material/Event";
import { StatTile } from "./StatTile";
import { StatTileData } from "../types";

type StatsRowProps = {
  attendancePercentLabel: string;
  attendanceMeta: string;
  gradePercentLabel: string;
  gradeMeta: string;
  feesDueLabel: string;
  feesDueMeta: string;
  nextEventTitle: string;
  nextEventMeta: string;
};

export const StatsRow = ({
  attendancePercentLabel,
  attendanceMeta,
  gradePercentLabel,
  gradeMeta,
  feesDueLabel,
  feesDueMeta,
  nextEventTitle,
  nextEventMeta,
}: StatsRowProps) => {
  const theme = useTheme();

  const tiles: StatTileData[] = [
    {
      id: "attendance",
      label: "Attendance",
      value: attendancePercentLabel,
      meta: attendanceMeta,
      icon: <FactCheckIcon fontSize="small" />,
      accentColor: theme.palette.success.main,
    },
    {
      id: "grade",
      label: "Average Grade",
      value: gradePercentLabel,
      meta: gradeMeta,
      icon: <SchoolIcon fontSize="small" />,
      accentColor: theme.palette.primary.main,
    },
    {
      id: "fees",
      label: "Fees Due",
      value: feesDueLabel,
      meta: feesDueMeta,
      icon: <AccountBalanceWalletIcon fontSize="small" />,
      accentColor: theme.palette.warning.main,
    },
    {
      id: "next-event",
      label: "Next Event",
      value: nextEventTitle,
      meta: nextEventMeta,
      icon: <EventIcon fontSize="small" />,
      accentColor: theme.palette.grey[600],
    },
  ];

  return (
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: { xs: "1fr 1fr", md: "repeat(4, 1fr)" },
        gap: { xs: 1.5, sm: 2 },
      }}
    >
      {tiles.map((tile) => (
        <StatTile key={tile.id} data={tile} />
      ))}
    </Box>
  );
};
